import { render, staticRenderFns } from "./PaymentMethodsTab.vue?vue&type=template&id=1127d368&"
import script from "./PaymentMethodsTab.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1127d368')) {
      api.createRecord('1127d368', component.options)
    } else {
      api.reload('1127d368', component.options)
    }
    module.hot.accept("./PaymentMethodsTab.vue?vue&type=template&id=1127d368&", function () {
      api.rerender('1127d368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/profile/screens/ProfileScreen/PaymentMethodsTab.vue"
export default component.exports